export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0A]">
      <div className="max-w-[1180px] mx-auto px-5 md:px-10 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          {/* Left */}
          <div>
            <p className="text-[15px] font-semibold text-[#F7F7F5] mb-1">
              The Fussed Bulb
            </p>
            <p className="text-[13px] text-[rgba(247,247,245,0.4)]">
              Built by Founders. For Founders.
            </p>
          </div>

          {/* Right */}
          <div className="flex items-center gap-6">
            <a
              href="mailto:letsrock@thefussedbulb.com"
              className="text-[13px] text-[rgba(247,247,245,0.45)] hover:text-[#F7F7F5] transition-colors duration-300 no-underline"
            >
              Email
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(247,247,245,0.45)] hover:text-[#F7F7F5] transition-colors duration-300 no-underline"
            >
              LinkedIn
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[13px] text-[rgba(247,247,245,0.45)] hover:text-[#F7F7F5] transition-colors duration-300 no-underline"
            >
              Instagram
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[rgba(247,247,245,0.06)]">
          <p className="text-[12px] text-[rgba(247,247,245,0.2)]">
            © {currentYear} The Fussed Bulb. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
